import { createSlice } from "@reduxjs/toolkit";

import { getAssignedInventoryItems, triggerInventoryRestock } from "./InventoryActions";

const initialState = {
  loading: false,
};

const InventorySlice = createSlice({
  name: "Inventory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(triggerInventoryRestock.pending, (state) => {
        state.loading = true;
      })
      .addCase(triggerInventoryRestock.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(triggerInventoryRestock.rejected, (state) => {
        state.loading = false;
      });

    builder.addCase(getAssignedInventoryItems.pending, (state) => {
      state.loading = true;
    })
      .addCase(getAssignedInventoryItems.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getAssignedInventoryItems.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default InventorySlice.reducer;
